import { HorizontalRule } from './HorizontalRule'

export default HorizontalRule
